module.exports = __webpack_public_path__ + "media/2500-3_YR_2022_Vishing.46738450.mp4";